import jQuery from '@nuskin/nuskinjquery';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace AjaxObject
 */
jQuery.AjaxObject = function AjaxObj (minAjaxCallWaitTimeInit){
    var minAjaxCallWaitTime = minAjaxCallWaitTimeInit === undefined ? 20000 : minAjaxCallWaitTimeInit; // In milliseconds
    var maxJsonDataLengthForStorage = 1000;
    var waitTimeCookiePrefix = "ajaxWaitTimeStamp - ";
    var urlDataPrefix = "urlData - ";
    var previousPageCookieName = "previous page:";
    var previousPageUrlsCookieName = "previousPageUrlCookieNames";
    var previousPageCookieNames = [];
    var callbacksEnabled = true;
    var creationTime = new Date().getTime();
    var jqXHR;
    var urlOfCall;
    var errorListener = null;

    this.getJson = function(url, successCallBack, failedCallBack){
        var ajaxCall = function () {
            jqXHR = $.getJSON(url, function (data) {
                // Put the JSON data in a cookie.
                if (minAjaxCallWaitTime != 0){
                    writeJsonData(urlDataPrefix + url, data);
                }

                if ((successCallBack !== undefined && successCallBack != null) && callbacksEnabled) {
                    successCallBack(data);
                }
            })
                .fail(function (jqXHR, textStatus, error) {
                    if (callbacksEnabled) {
                        if (failedCallBack !== undefined && failedCallBack != null) {
                            failedCallBack(jqXHR, textStatus, error, urlOfCall);
                        }
                        else {
                            var errorMsg = handleDefaultAjaxErrors(jqXHR, textStatus, error);

                            if (errorMsg.errorString !== undefined && errorMsg.errorString.length > 0){
                                alert(errorMsg.errorString + '   ' + errorMsg.failedUrl);
                            }
                        }
                    }
                });
        };

        executeCall(url, ajaxCall, successCallBack);

        return jqXHR;
    };

    this.getJsonWithOptions = function(url, successCallBack, failedCallBack, options){
        var ajaxOptions = buildAjaxOptions(url, successCallBack, failedCallBack, options);

        var ajaxGetCall = function () {
            ajaxOptions.type = 'GET';
            jqXHR = $.ajax(ajaxOptions);
        };

        executeCall(url, ajaxGetCall, successCallBack);

        return jqXHR;
    };

    this.postJson = function(url, data, successCallBack, failedCallBack){
        var ajaxCall = function(){
            jqXHR = $.post(url, data, function(data){
                if ((successCallBack !== undefined || successCallBack != null) && callbacksEnabled){
                    successCallBack(data);
                }
            }, "json")
                .fail(function(jqXHR, textStatus, error) {
                    if (callbacksEnabled){
                        if (failedCallBack !== undefined && failedCallBack != null){
                            failedCallBack(jqXHR, textStatus, error, urlOfCall);
                        }
                        else{
                            var errorMsg = handleDefaultAjaxErrors(jqXHR, textStatus, error);

                            if (errorMsg.errorString !== undefined && errorMsg.errorString.length > 0){
                                alert(errorMsg.errorString + '   ' + errorMsg.failedUrl);
                            }
                        }
                    }
                });
        };

        executeCall(url, ajaxCall, successCallBack);

        return jqXHR;
    };

    this.postJsonWithOptions = function(url, data, successCallBack, failedCallBack, options){
        var ajaxOptions = buildAjaxOptions(url, successCallBack, failedCallBack, options);

        var ajaxGetCall = function () {
            ajaxOptions.type = 'POST';
            ajaxOptions.data = data;
            jqXHR = $.ajax(ajaxOptions);
        };

        executeCall(url, ajaxGetCall, successCallBack);

        return jqXHR;
    };

    this.disableCallbacks = function(){
        // Disable callback updates.
        callbacksEnabled = false;

        // Clear cache
        deletePreviousPageCookies();
    };

    this.getCreationTime = function(){
        return creationTime;
    };

    this.getMaxJsonDataLengthForStorage = function(){
        return maxJsonDataLengthForStorage;
    };

    this.getJqXHR = function(){
        return jqXHR;
    };

    this.handleDefaultAjaxErrors = function(jqXHR, textStatus, error){
        return handleDefaultAjaxErrors(jqXHR, textStatus, error);
    };

    this.displayErrors = function(ajaxErrorListener){
        if (ajaxErrorListener != null && isFunction(ajaxErrorListener)){
            errorListener = ajaxErrorListener;
        }

        return jqXHR;
    };

    //----------------------------------------------------------------------
    //
    //                  Declare Private Methods
    //
    //----------------------------------------------------------------------
    function isFunction(x) {
        return Object.prototype.toString.call(x) == '[object Function]';
    }

    function buildAjaxOptions(url, successCallBack, failedCallBack, options){
        var ajaxOptions = (options !== undefined && options != null) ? options : {};

        ajaxOptions.url = url;
        ajaxOptions.dataType = 'json';
        ajaxOptions.contentType = 'application/json';
        if (options.cache === undefined) {
            ajaxOptions.cache = false; // This adds a timestamp to the url at call time so that IE doesn't cache the results.
        }
        // Add in our success & fail callbacks
        ajaxOptions.success = function(data){
            // Put the JSON data in a cookie.
            if (minAjaxCallWaitTime != 0){
                writeJsonData(urlDataPrefix + url, data);
            }

            if ((successCallBack !== undefined && successCallBack != null) && callbacksEnabled) {
                successCallBack(data);
            }
        };
        ajaxOptions.error = function(jqXHR, textStatus, error){
            if (callbacksEnabled) {
                if (failedCallBack !== undefined && failedCallBack != null) {
                    failedCallBack(jqXHR, textStatus, error, urlOfCall);
                }
                else {
                    var errorMsg = handleDefaultAjaxErrors(jqXHR, textStatus, error);

                    if (errorMsg.errorString !== undefined && errorMsg.errorString.length > 0){
                        alert(errorMsg.errorString + '   ' + errorMsg.failedUrl);
                    }
                }
            }
        };

        return ajaxOptions;
    }

    function executeCall(url, ajaxCall, successCallBack){
        urlOfCall = url;

        if (minAjaxCallWaitTime == 0){
            ajaxCall();
        }
        else{
            // Get the time stamp from the cookie
            var lastCallTime = getLastCallTime(url);
            var currentTime = new Date().getTime();

            // Clear previous page cookies if they exist.
            var cookiesWereCleared = clearPageCookies();

            // Enable callbacks
            callbacksEnabled = true;

            // If the page has changed since the last call of the url or the time stamp is less than required minimum wait time we can make the ajax call.
            if (cookiesWereCleared || ((currentTime - minAjaxCallWaitTime) >= lastCallTime)){
                // Make the ajax call
                ajaxCall();

                // Set the time the last call was made for this url.
                setLastCallTime(url, currentTime);
            }
            else{
                // Refresh the screen with the current data because we have not waited long enough to hit the server for live data.
                var data = readCookie(urlDataPrefix + url);

                if (data != null){
                    data.readFromCookie = true;
                    data.maxJsonDataLengthForStorage = maxJsonDataLengthForStorage;

                    if (successCallBack !== undefined || successCallBack != null){
                        successCallBack(data);
                    }
                }
            }
        }
    }

    function getLastCallTime(url){
        var lastCallTime = readCookie(waitTimeCookiePrefix + url);
        if (lastCallTime == null || lastCallTime.length == 0){
            lastCallTime = 0;
        }
        return lastCallTime;
    }

    function setLastCallTime(url, lastCallTime){
        writeCookie(waitTimeCookiePrefix + url, lastCallTime);
    }

    function haveChangedPagesSinceLastCall(){
        var previousPage = readCookie('previousPageCookieName');
        var currentPage = window.location.href;

        return previousPage != currentPage;
    }

    function clearPageCookies(){
        var cookiesWereCleared = false;

        // Clear cookies for previous page out of local storage.
        if (haveChangedPagesSinceLastCall()){
            // Delete all cookies that related to the previous page.
            deletePreviousPageCookies();

            // Store the current page as the new previous page.
            writeCookie('previousPageCookieName', window.location.href);

            cookiesWereCleared = true;
        }

        return cookiesWereCleared;
    }

    function deletePreviousPageCookies(){
        var previousPageCookies = readCookie(previousPageUrlsCookieName);

        if (previousPageCookies != null){
            for (var i=0;i<previousPageCookies.length;i++){
                localStorage.removeItem(previousPageCookies[i]);
            }
        }
    }

    function writeJsonData(url, data){
        if (data != null){
            if (data.length > maxJsonDataLengthForStorage){
                var thousandDataRow = [];
                for (var i=0;i<maxJsonDataLengthForStorage; i++){
                    thousandDataRow[i] = data[i];
                }
                writeCookie(url, thousandDataRow);
            }
            else{
                writeCookie(url, data);
            }
        }
    }

    function readCookie(urlCookieName){
        return localStorage.getItem(urlCookieName);
    }

    function writeCookie(urlCookieName, value){
        localStorage.setItem(urlCookieName, value);

        // Add the url cookie name to the array so we can delete the cookie if the page changes.
        previousPageCookieNames.push(urlCookieName);

        // Store the array as a cookie.
        localStorage.setItem(previousPageUrlsCookieName, previousPageCookieNames);
    }

    function handleDefaultAjaxErrors(jqXHR, textStatus, error){
        var errorString = "";
        var failedUrl = "";

        if (jqXHR != null){
            var errorStr;
            var failedUrlLbl;

            // First try to get value from configuration
            if (typeof errorMsg !=="undefined" && errorMsg.length > 0){
                errorStr = errorMsg;
            }
            // Use default value.
            else{
                errorStr = "Error";
            }

            // First try to get value from configuration
            if (failedUrl !== undefined && failedUrl.length > 0){
                failedUrlLbl = failedUrl;
            }
            // Use default value.
            else{
                failedUrlLbl = "Failed URL:";
            }

            // See http://en.wikipedia.org/wiki/List_of_HTTP_status_codes for list of available status codes.
            switch (jqXHR.status){
                case 0:
                    if (jqXHR.statusText == "timeout"){
                        // First try to get value from configuration
                        if (typeof timeoutErrorMsg !=="undefined" && timeoutErrorMsg.length > 0){
                            errorString = timeoutErrorMsg;
                        }
                        // Use default value.
                        else{
                            errorString = "An error has occurred processing your request. Please try again.";
                        }
                    }
                    break;

                case 400:
                    // First try to get value from configuration
                    if (typeof error400Msg !=="undefined" && error400Msg.length > 0){
                        errorString = error400Msg;
                    }
                    // Use default value.
                    else{
                        errorString = "Error 400 - Server understood the request but request content was invalid.";
                    }
                    break;

                case 401:
                    // First try to get value from configuration
                    if (typeof error401Msg !=="undefined" && error401Msg.length > 0){
                        errorString = error401Msg;
                    }
                    // Use default value.
                    else{
                        errorString = "Error 401 - Unauthorised access.";
                    }
                    break;

                case 403:
                    // First try to get value from configuration
                    if (typeof error403Msg !=="undefined" && error403Msg.length > 0){
                        errorString = error403Msg;
                    }
                    // Use default value.
                    else{
                        errorString = "Error 403 - Forbidden. Resource can't be accessed.";
                    }
                    break;

                case 404:
                    // First try to get value from configuration
                    if (typeof error404Msg !=="undefined" && error404Msg.length > 0){
                        errorString = error404Msg;
                    }
                    // Use default value.
                    else{
                        errorString = "Error 404 - URL not found.";
                    }
                    break;

                case 500:
                    // First try to get value from configuration
                    if (typeof error500Msg !=="undefined" && error500Msg.length > 0){
                        errorString = error500Msg;
                    }
                    // Use default value.
                    else{
                        errorString = "Error 500 - Internal Server Error.";
                    }
                    break;

                case 503:
                    // First try to get value from configuration
                    if (typeof error503Msg !=="undefined" && error503Msg.length > 0){
                        errorString = error503Msg;
                    }
                    // Use default value.
                    else{
                        errorString = "Error 503 - Service Unavailable.";
                    }
                    break;

                default:
                    var jqXHRStatus = jqXHR.status;
                    var jqXHRStatusText = jqXHR.statusText;
                    var jqXHRUrl = jqXHR.url;

                    errorString = errorStr;

                    if (jqXHRStatus !== undefined){
                        errorString += " " + jqXHRStatus;
                    }
                    if (jqXHRStatusText !== undefined && jqXHRStatusText.length > 0){
                        errorString += " - " + jqXHRStatusText;
                    }
                    if (jqXHRUrl !== undefined && jqXHRUrl.length > 0){
                        failedUrl = failedUrlLbl + " " + jqXHRUrl;
                    }

                    break;
            }

            if (urlOfCall !== undefined && failedUrl.indexOf(failedUrlLbl) == -1){
                failedUrl = failedUrlLbl + " " + urlOfCall;
            }
        }

        return {errorString: errorString, failedUrl: failedUrl};
    }
};
$.ajaxWrapper = {
    getJson: function(url, successCallBack, failedCallBack, minAjaxCallWaitTimeInit){
        var ajaxObj = new jQuery.AjaxObject(minAjaxCallWaitTimeInit);

        ajaxObj.getJson(url, successCallBack, failedCallBack);
        return ajaxObj;
    },
    getJsonWithOptions: function(url, successCallBack, failedCallBack, options, minAjaxCallWaitTimeInit){
        var ajaxObj = new jQuery.AjaxObject(minAjaxCallWaitTimeInit);

        ajaxObj.getJsonWithOptions(url, successCallBack, failedCallBack, options);
        return ajaxObj;
    },
    postJson: function(url, data, successCallBack, failedCallBack, minAjaxCallWaitTimeInit){
        var ajaxObj = new jQuery.AjaxObject(minAjaxCallWaitTimeInit);

        ajaxObj.postJson(url, data, successCallBack, failedCallBack);
        return ajaxObj;
    },
    postJsonWithOptions: function(url, data, successCallBack, failedCallBack, options, minAjaxCallWaitTimeInit){
        var ajaxObj = new jQuery.AjaxObject(minAjaxCallWaitTimeInit);

        ajaxObj.postJsonWithOptions(url, data, successCallBack, failedCallBack, options);
        return ajaxObj;
    },

    handleDefaultAjaxErrors: function(jqXHR, textStatus, error){
        var ajaxObj = new jQuery.AjaxObject();

        return ajaxObj.handleDefaultAjaxErrors(jqXHR, textStatus, error);
    }
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/ajaxWrapper.js
// module id = 283
// module chunks = 0